/**
 * Enum containing the keys/names of name spaces files containing i18n data
 */
export enum TranslationNS {
  CompanyInfo = 'company-info',
  CompanyAdmin = 'company-admin',
  LeaveManagement = 'leave-management',
  Auth = 'auth',
  CompanyAsset = 'company-asset',
  Department = 'department',
  Designation = 'designation',
  Employee = 'employee',
  Dashboard = 'dashboard',
  Profile = 'profile',
  Roles = 'roles',
  sidebar = 'sidebar',
  Vendors = 'vendors',
  Notes = 'notes',
  Common = 'common',
  LibsCommon = 'libsCommon',
  TaskLists = 'task-lists',
  EmployeeBoarding = 'employee-boarding',
  AdminAssignedProcess = 'admin-assigned-process',
  Tour = 'tour',
  Survey = 'survey',
}
